import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { openid } from '@/core';
import { useUserContextSelector } from '@/redux';
import { confirmation } from '@/components';
import classNames from 'classnames';
import classes from './BurgerMenu.module.scss';

type BurgerMenuPropsType = {
  isActive: boolean;
  setInactive: () => void;
};

export const BurgerMenu = ({ isActive, setInactive }: BurgerMenuPropsType) => {
  const { t } = useTranslation();
  const [name, hasRole] = useUserContextSelector((x) => [x.name, x.hasRole]);

  const showSignOutConfirmationDialog = () => {
    confirmation.show({
      title: t('logoutConfirmation.title'),
      body: t('logoutConfirmation.body'),
      onConfirm: () => openid.logout(),
    });
  };

  return (
    <div className={classNames(classes.burgerMenu, isActive && classes.active)} onClick={setInactive}>
      <div
        className={classNames(classes.burgerMenu__content, isActive && classes.active)}
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <Button
            icon={<CloseOutlined />}
            type="text"
            className={classes.buttonClose}
            onClick={setInactive}
          ></Button>
          <div className={classes.burgerMenu__list} onClick={setInactive}>
            <NavLink to="/projects">{t('projects.title')}</NavLink>
            {hasRole('ADMIN') ? <NavLink to="/users">{t('users.title')}</NavLink> : null}
            <NavLink to="/me">{name}</NavLink>
            <NavLink to="/change-password">{t('nav.changePassword')}</NavLink>
            <div onClick={showSignOutConfirmationDialog}>{t('nav.logout')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
